export default {"src":"/_next/static/media/XLT.1f2442f2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};